import { openModal } from '@core/components/ModalStack';
import { AddEditHelpArticleCategoryModalProps } from './AddEditHelpArticleCategoryModal';

export async function openAddEditHelpArticleCategoryModal(props: AddEditHelpArticleCategoryModalProps) {
  const { AddEditHelpArticleCategoryModal } = await import('./AddEditHelpArticleCategoryModal');

  openModal(AddEditHelpArticleCategoryModal, props);
}
